var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleReviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26430",
    "data-name": "Group 26430",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260.584,
    height: 38.198,
    viewBox: "0 0 260.584 38.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677",
    "data-name": "Rectangle 2677",
    width: 89.053,
    height: 29.198,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26427",
    "data-name": "Group 26427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26426",
    "data-name": "Group 26426",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52249",
    "data-name": "Path 52249",
    d: "M21.894,10.311H11.413v3.083h7.46c-.364,4.324-3.961,6.168-7.357,6.168A8.1,8.1,0,0,1,3.38,11.353a8.118,8.118,0,0,1,8.145-8.262A8,8,0,0,1,17.081,5.32L19.24,3.084A10.977,10.977,0,0,0,11.415,0,11.514,11.514,0,0,0,0,11.3,11.477,11.477,0,0,0,11.579,22.653c6.064,0,10.5-4.154,10.5-10.3a9.243,9.243,0,0,0-.188-2.045Z",
    transform: "translate(0 0.001)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52250",
    "data-name": "Path 52250",
    d: "M267.8,89.748a7.281,7.281,0,1,0,7.306,7.306,7.194,7.194,0,0,0-7.306-7.306m.042,2.86a4.43,4.43,0,1,1-4.167,4.406,4.186,4.186,0,0,1,4.167-4.406",
    transform: "translate(-237.037 -81.67)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52251",
    "data-name": "Path 52251",
    d: "M443.656,89.748a7.281,7.281,0,1,0,7.306,7.306,7.194,7.194,0,0,0-7.306-7.306m.042,2.86a4.43,4.43,0,1,1-4.167,4.406A4.186,4.186,0,0,1,443.7,92.608Z",
    transform: "translate(-397.06 -81.67)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52252",
    "data-name": "Path 52252",
    d: "M620.453,89.834a7.29,7.29,0,0,0-.067,14.564,4.81,4.81,0,0,0,3.993-1.769v1.436a3.654,3.654,0,0,1-3.827,4.016,4.037,4.037,0,0,1-3.727-2.592l-2.8,1.17a7,7,0,0,0,6.549,4.288c3.891,0,6.857-2.451,6.857-7.591V90.092h-3.053v1.413a5.15,5.15,0,0,0-3.926-1.671Zm.283,2.854a4.118,4.118,0,0,1,3.889,4.436,4.069,4.069,0,0,1-3.931,4.411,4.137,4.137,0,0,1-4.028-4.384,4.2,4.2,0,0,1,4.07-4.463Z",
    transform: "translate(-558.244 -81.748)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52253",
    "data-name": "Path 52253",
    d: "M847.778,89.641c-3.692,0-6.792,2.937-6.792,7.271a7.041,7.041,0,0,0,7.146,7.306,7.387,7.387,0,0,0,6.1-3.2l-2.517-1.675a4.075,4.075,0,0,1-3.567,2,3.745,3.745,0,0,1-3.571-2.207l9.763-4.051-.507-1.187a6.592,6.592,0,0,0-6.055-4.266Zm.127,2.8A2.9,2.9,0,0,1,850.6,94l-6.52,2.725a4.044,4.044,0,0,1,3.826-4.28",
    transform: "translate(-765.287 -81.572)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2676",
    "data-name": "Rectangle 2676",
    width: 2.99,
    height: 21.461,
    transform: "translate(71.225 0.753)",
    fill: "#34a853"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26429",
    "data-name": "Group 26429",
    transform: "translate(142.058 2.414)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rated_excellent_by_our_clients",
    "data-name": "Rated excellent by our clients",
    transform: "translate(2.945 33.785)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Rated excellent by our clients")), /*#__PURE__*/React.createElement("g", {
    id: "Group_26428",
    "data-name": "Group 26428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M10.675,0l3.576,6.4,7.1,1.476L16.461,13.3l.811,7.31-6.6-3.042-6.6,3.042.811-7.31L0,7.874,7.1,6.4Z",
    transform: "translate(97.177)",
    fill: "#fbbc2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M10.675,0l3.576,6.4,7.1,1.476L16.461,13.3l.811,7.31-6.6-3.042-6.6,3.042.811-7.31L0,7.874,7.1,6.4Z",
    transform: "translate(72.882)",
    fill: "#fbbc2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M10.675,0l3.576,6.4,7.1,1.476L16.461,13.3l.811,7.31-6.6-3.042-6.6,3.042.811-7.31L0,7.874,7.1,6.4Z",
    transform: "translate(48.588)",
    fill: "#fbbc2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M10.675,0l3.576,6.4,7.1,1.476L16.461,13.3l.811,7.31-6.6-3.042-6.6,3.042.811-7.31L0,7.874,7.1,6.4Z",
    transform: "translate(24.294)",
    fill: "#fbbc2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M10.675,0l3.576,6.4,7.1,1.476L16.461,13.3l.811,7.31-6.6-3.042-6.6,3.042.811-7.31L0,7.874,7.1,6.4Z",
    fill: "#fbbc2c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52254",
    "data-name": "Path 52254",
    d: "M-6717,8555v21.8",
    transform: "translate(6832.555 -8552.586)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleReviews);
export default __webpack_public_path__ + "static/media/google-reviews.4af288f51e5cb5fda64c72abb5d937b3.svg";
export { ForwardRef as ReactComponent };